export default {
  auth: {
    signInPageTitle: "Sign in to your account",
    form: {
      username: "Email",
      password: "Password",
    },
    action: {
      signIn: "Sign in",
    },
  },
  login: {
    welcomeBack: "Welcome Back",
    signInToAccount: "Sign in to your CARU account",
    emailAddress: "Email Address",
    enterEmail: "Enter your email",
    sendVerificationCode: "Send Verification Code",
    sendingCode: "Sending Code...",
    checkYourEmail: "Check Your Email",
    checkSpamFolder: "Please check your spam folder if you don't see the email.",
    sentCodeTo: "We sent a verification code to",
    verificationCode: "Verification Code",
    enterCode: "Enter 6-digit code",
    verifyAndSignIn: "Verify & Sign In",
    verifying: "Verifying...",
    resendCode: "Resend Code",
    resending: "Sending...",
    codeResent: "Code Sent",
    codeResentMessage: "A new verification code has been sent to your email",
    useDifferentEmail: "← Use a different email",
    allRightsReserved: "All rights reserved",
    loginWithPassword: "Login with password",
    loginWithCode: "Login with code",
    password: "Password",
    enterPassword: "Enter your password",
    signIn: "Sign In",
    signingIn: "Signing in...",
    forgotPassword: "Forgot password?",
    resetPasswordDescription: "Enter your email address to receive a code to reset your password.",
    resetPassword: "Reset Password",
    sendResetCode: "Send Reset Code",
    newPassword: "New Password",
    enterNewPassword: "Enter your new password",
    passwordResetSuccess: "Your password has been successfully reset",
    backToLogin: "Back to Login",
    errors: {
      sendingCode: "An error occurred sending the code.",
      invalidCode: "Invalid code or an error occurred.",
      signInNotCompleted: "Sign-in not completed. Please try again.",
      unexpectedStep: "Unexpected next step",
      noEmailAttribute: "No user found with this email address. Please contact support.",
      userNotFound: "No account found with this email address",
      userDisabled: "This account has been disabled",
      userNotConfirmed: "Please verify your email first",
      tooManyAttempts: "Too many failed attempts. Please try again later",
      accountLocked: "Account temporarily locked due to too many failed attempts",
      otpExpired: "Verification code expired. Please request a new one",
      sessionInvalid: "Your session has expired. Please start over",
      networkError: "Network error. Please check your connection",
      generic: "An error occurred. Please try again",
    },
  },
  notifications: {
    mutations: {
      success: "Successfully saved!",
      error: "Error occurred",
      delivering: "The devices will receive the updated config as soon as they are online.",
      contactSupport: "Please contact CARU support",
      jsonParse: "Server could not parse JSON. Please check your data",
      templateStored: "Configuration template was stored successfully.",
      templateStoredFailure: "Error occurred! Please try again or contact the CARU support Team.",
      tenantCreated: "Tenant { tenant } successfully created.",
      userInvited: "User was invited!",
      userInvitedDescription: "User was successfully invited and email with temporary password was send",
      userInvitedError: "Something went wrong please try again later or contact CARU support",
      userUpdates: "User was successfully updated!",
      deleteUser: "User was successfully deleted!",
    },
    auth: {
      error: "Error occurred",
      invalidCredentials: "Incorrect username or password.",
    },
  },
  device: {
    label: "device | devices",
    selectionSingular: "{ selection } device selected",
    selection: "{ selection } of { length } devices selected",
    listPageTitle: "Manage Users",
    detailsPageTitle: "Account",
    softwareSupport:
      "Your device is equipped with an outdated software version. Please switch on the device so that the latest software can be installed automatically. As soon as the update has been carried out, the device can be configured in the platform as usual. If you have any further questions, please contact our support team:",
    header: {
      deviceConnectivityStatus: "Device Connectivity Status",
      connectivityStatus: "Connectivity Status",
      errorStatus: "Error Status",
      serialNumber: "Serial Number",
      firmware: "Firmware",
      id: "Device ID",
      tenant: "Tenant Name",
      version: "Version",
      notifications: "Notifications",
      copyConfiguration: "Copy Configuration",
      setGroup: "Set devices group",
      tabNotification: "Plugout Notifications",
      unknown: "UNKNOWN",
      bracelets: "Bracelets",
      braceletColumn: "Bracelet IDs",
      arcConfig: "Alarm Center",
      setOwner: "Set device owner",
      dailyCheck: "Daily Check In",
      co2Toggle: "Co2 Indication",
      hydrationReminder: "Hydration Reminder",
      wifiConnection: "Wifi Connection",
      changeTenant: "Change Tenant",
      changeTenantDescription: "Select a new tenant for the device.",
      changeTenantsDescription: "Select a new tenant for the devices.",
      changeTenantLabel: "Select Tenant:",
      sureTenantChange: "Are you sure you want to change the tenant?",
    },
    co2Settings: {
      dayNightMode: "Activate Day/Night Mode",
      intervalSelection: "Set Time Interval",
      intervalDescriptionOff: "The device lights are turned off from { start } to { end }.",
      intervalDescriptionDimmed: "The device is set to dimmed mode from { start } to { end }.",
      nightMode: "LED Light",
      nightModeActive: "Night mode active",
      nightModeInactive: "Night mode inactive",
      nightModes: {
        active: "Active",
        dimmed: "Dimmed",
        off: "Off",
      },
    },
    form: {
      permissions: "Permissions",
      roles: {
        none: "No Access",
        viewer: "Viewer",
        admin: "Admin",
      },
      notifications: "Notifications",
      alarmDestinations: "Alarm Destinations",
      bracelets: "Bracelets",
      sourceDevice: "Source Device",
      ownerName: "Owner Name",
      selectDevice: "- Select Device -",
      msisdn: "SIM card number",
      nomsisdn: "No SIM card number set",
      permissionTenant: "You do not have ADMIN rights for this tenant.",
    },
    action: {
      diagnose: "Diagnose",
      group: "Group",
      owner: "Owner",
      alarmConfig: "Alarm Config",
      notifications: "Notifications",
      reset: "Reset",
      reboot: "Reboot",
      shutdown: "Shutdown",
      deactivate: "Deactivate",
      selfDiagnosis: "Self Diagnosis",
      copyConfig: "Copy Config",
      changeOwner: "Change Owner",
      applyConfigTemplate: "Apply Config Template",
      cancel: "Cancel",
      save: "Save",
      addBracelets: "Add Bracelets",
    },
    general: {
      firmware: "Firmware Version",
      modem: "Modem Status",
      wifi: "WiFi Status",
      battery: "Battery Status",
      dailyCheckIn: "Daily Check In",
    },
    events: {
      pageTitle: "Device Events",
      header: {
        type: "Event",
        timestamp: "Timestamp",
      },
      empty: "No events available",
    },
    feature: {
      header: {
        featureFlags: "Feature Flags",
        developmentSettings: "Development Settings",
      },
      audio: "Audio: Sound Volume",
      cortex: "Cortex: Log Level",
    },
    settings: {
      general: "General",
      alertDestinations: "Alert Destinations",
      bracelets: "Bracelets",
      events: "Events",
      features: "Features",
    },
    tooltip: {
      braceletPresenceStatus: "Bracelet presence status",
      dailyCheckIn: "Daily check in status",
      braceletBatteryStatus: "Bracelet battery status",
      presenceStatus: "Presence status",
      wifiStatus: "Wifi status",
      powerSupplyStatus: "Power supply status",
    },
    placeholder: "Search device IDs",
    loading: "Loading devices...",
    errorStatus: {
      ok: "OK",
      error: "Error",
      unknown: "Unknown",
      off: "Off",
      emptyBattery: "Battery Empty",
      missingDevice: "Offline",
      lowPowerMode: "Power-Savings-Mode",
    },
  },
  notification: {
    deviceReset: "Device reset started...",
    deviceDiagnosis: "Device diagnosis started...",
    deviceRefresh: "{serialNumber} updated",
    header: {
      plugoutNotifications: "Plugout Notifications",
    },
    form: {
      sms: "SMS",
      email: "Email",
    },
    action: {
      addNotificationReceiver: "Add Notification Receiver",
    },
  },
  user: {
    listPageTitle: "Manage Users",
    detailsPageTitle: "Account",
    header: {
      name: "Name",
      tenant: "Tenant",
      role: "Role",
      edit: "Edit",
    },
    form: {
      permissions: "Permissions",
      roles: {
        none: "No Access",
        viewer: "Viewer",
        admin: "Admin",
      },
    },
    placeholder: "Search devices",
  },
  alert: {
    applyNotificationTitle: "Apply notification configuration?",
    applyAlarmTitle: "Apply alarm configuration?",
    applyGroupTitle: "Set group ?",
    applyOwnerTitle: "Set owner ?",
    resetDeviceTitle: "Reset Device",
    applyBatchResetTitle: "Device Reset",
    applyBatchRebootTitle: "Device Reboot",
    applyBatchShutdownTitle: "Device Shutdown",
    applyBatchDeactivateTitle: "Device Deactivate",
    applyChangesTitle: "Confirm changes",
    leavePage: "Leave Page",
    applyBatchResetDescription: "Are you sure you want to reset ${length} devices? This action cannot be undone.",
    applyBatchRebootDescription: "Are you sure you want to reboot ${length} devices?",
    applyBatchShutdownDescription: "Are you sure you want to shutdown ${length} devices?",
    applyBatchDeactivateDescription: "Are you sure you want to deactivate ${length} devices?",
    applyNotificationDescription:
      "Are you sure you want to apply this notification configuration to all selected devices? All existing configurations will be overwritten. This action cannot be undone.",
    applyAlarmDescription:
      "Are you sure you want to apply this alarm configuration to all selected devices? All existing configurations will be overwritten. This action cannot be undone.",
    applyGroupDescription:
      "Are you sure you want to set this group name to all selected devices? All existing groups will be overwritten. This action cannot be undone.",
    applyOwnerDescription:
      "Are you sure you want to set this owner name to all selected devices? All existing owners will be overwritten. This action cannot be undone.",
    resetDeviceDescription: "Are you sure you want to reset this device? This action cannot be undone.",
    applyChangesDescription: "Are you sure you want to apply the changes?",
    leavePageDescription: "You have unsaved changes. Are you sure you want to leave without saving?",
    deleteTemplateTitle: "Delete Template?",
    deleteTemplateDescription: "Are you sure you want to delete the template?",
  },
  configuration: {
    header: {
      config: "Configuration",
    },
    expertMode: "Expert Mode",
    editJson: "Edit Json",
  },
  safety: {
    header: {
      safety: "Safety",
    },
  },
  health: {
    header: {
      health: "Health",
    },
  },
  system: {
    header: {
      system: "System",
      volumeSettings: "Device Volume",
    },
    volume: {
      quiet: "quiet",
      default: "default",
      loud: "loud",
    },
  },
  scaip: {
    form: {
      header: "Set Controller ID",
      controllerId: "Controller ID",
      callerId: "Caller ID",
      errorControllerId: "Controller ID can only contain upper case letters and numbers",
    },
  },
  userManagement: {
    listPageTitle: "User Management",
    tab: {
      user: "Users",
      tenants: "Tenants",
      inviteUser: "Invite User",
      editUser: "Edit User",
      createTenant: "Create Tenant",
      updateTenant: "Update Tenant",
    },
    userTable: {
      name: "Name",
      email: "Email",
      phone: "Phone Number",
      tenants: "Tenants",
      role: "Role",
      state: "State",
      pwd: "Password",
      pwdRepeat: "Repeat Password",
    },
    tenantTable: {
      name: "Name",
      slug: "Slug",
      devices: "Devices",
      serialNumber: "Serial Number",
      users: "Users",
      showLess: "Show less devices",
      showAll: "Show all devices",
      deviceTenants: "Devices of Tenant",
      newDevices: "New Devices",
      tenantExists: "Tenant name is already used",
    },
    action: {
      inviteUser: "Invite User",
      inviteUserDescription:
        "Are you sure you want to invite the User? An Email will be send with the temporary password",
      deleteUser: "Delete User",
      deleteUserDescription: "Are you sure you want to delete following user: {email}?",
      updateUser: "Change User",
      updateUserDescription: "Are you sure you want to update the user?",
      createTenant: "Create Tenant",
      createTenantDescription: "Are you sure you want to create the tenant?",
      updateTenant: "Update Tenant",
      updateTenantDescription: "Are you sure you want to save the changes?",
    },
  },

  configTemplates: {
    listPageTitle: "Config Templates",
    listPageTitleEdit: "Config Template",
    header: {
      id: "Id",
      name: "Name",
      placeholder: "Placeholder",
      lastUpdate: "Last Updated",
      lastUpdateBy: "Last Change",
      owner: "Owner",
      applier: "Applier",
      edit: "Edit",
      template: "Template",
      preview: "Preview",
      example: "Example Value",
      noIdFound: "No Controller ID found",
    },
    loadPreviousControllerIds: "Load previous controller IDs",
    applyFailed: "The template could not be applied. No device was changed.",
    mergedInto: "Merged into config section:",
    loadPreviousControllerId: "Load previous controller ID",
    templateDescription: "Placeholders start and end with '$'.",
  },
  deviceAlarmsNotificationSubscription: {
    listPageTitle: "Email Notifications",
    listPageTitleEdit: "Email Notifications",
    emailList: "E-Mail list",
    emailListInputFieldText: "Add email address and press Enter or insert a list",
    emailListDescription:
      "You can add multiple emails by inserting a list separated by commas, spaces, or line breaks.",
    selectTenant: "Select organization",
    noTenant: "You have no clients assigned to you.",
    excludedDevice: "Excluded devices",
    excludedDeviceInputField: "Type serial number to search",
    excludedDeviceDescription: "Only lowercase letters and numbers (8 characters). You can also paste a list.",
    searchingDevices: "Loading devices...",
    invalidDeviceId: "Device ID must be exactly 8 alphanumeric characters (a-z, 0-9).",
    duplicateDeviceId: "This device has already been added.",
    deviceNotFoundInTenant: "Device not found in the selected organization.",
    subscriptionStatusSlider: "Subscription status",
    popups: {
      delete: {
        title: "Confirm Deletion",
        description: "Do you really want to delete these notification settings? This action cannot be undone.",
        actionText: "Delete",
      },
      create: {
        title: "Confirm Save",
        description: "Do you really want to save these notification settings?",
        actionText: "Save",
      },
      update: {
        title: "Confirm Update",
        description: "Do you really want to save the changes?",
        actionText: "Update",
      },
      abort: {
        title: "Confirm Cancellation",
        description: "Do you really want to discard unsaved changes? This action cannot be undone.",
        actionText: "Confirm",
      },
    },
  },
  alarm: {
    listPageTitle: "Alarm Center | Alarm Centers",
    header: {
      name: "Name",
      tenant: "Tenant",
      alertTriggers: "Alert Triggers",
      alarmDestinations: "Alarm Destinations",
    },
    destination: {
      pstn: "PSTN",
      sip: "SIP",
      arc: "ARC",
      isArc: "Is ARC",
      arcName: " ARC-Name (SCAIP-Server-Address)",
    },
    form: {
      name: "Name",
      host: "Host",
      port: "Port",
      username: "Username",
      password: "Password",
      tenant: "Tenant",
      changeTenant: "Change Tenant",
      country: {
        caru: "CARU",
        caritasSoest: "Caritas Soest",
      },
      selectArc: "-- Select ARC --",
      triggerByVoice: "Trigger by Voice",
      triggerByTouch: "Trigger by Touch",
      triggerByBracelet: "Trigger by Bracelet (Fall Detection)",
      triggerByVoiceOnBattery: "Enabled in battery mode",
      triggerByVoiceOnBatteryActive: "The battery lasts about 2h",
      triggerByVoiceOnBatteryInactive: "The battery lasts about 24h",
    },
    action: {
      addDestination: "Add Destination",
    },
    tooltip: {
      triggerByVoiceOnBatteryActive:
        "Voice emergency call initiation is disabled during a power interruption to minimize battery drain and maximize ride through time. During a power failure, no emergency call can be made by voice. Emergency calls can still be triggered via the radio transmitter and on CARU care.",
      triggerByVoiceOnBatteryInactive:
        "The emergency call can also be triggered by voice during a power failure. Due to the power consumption of the speech recognition, the time to bridge the interruption is limited.",
    },
  },
  dailyCheck: {
    status: {
      ok: "OK",
      disabled: "Disabled",
      missing: "Not confirmed",
      suspended: "Suspended",
      unknown: "Unknown",
    },
    form: {
      active: "Active",
      inactive: "Inactive",
      suspended: "Suspended",
      suspendedDate: "Suspended End Date",
      checkTime: "Check time",
      gracePeriod: "Grace period (min)",
      remindersDescription: "Reminders are played after {firstReminder} and {secondReminder} minutes",
    },
  },
  hydrationReminder: {
    titleDescription: "Reminders are played from {firstSlot} to {secondSlot} and {thirdSlot} to {fourthSlot}",
    reminderInterval: "Reminder Interval",
    intervalSelection: "Reminder Interval",
    intervalDescription: "Sounds are played around the selected time.",
    intervalPreviewDescription: "Reminders are played around:",
    previewSound: "Preview Sound",
    previewSoundDescription: "Sound is played in the browser",
    play: "Play",
    updateVersion:
      "This functionality is available from version 2023.3.3 ongoing. Please contact our support under <a href='mailto:email@example.com'>dennis.cserhati@caruhome.com</a> or 🇨🇭 +41 44 512 13 77 🇩🇪 +49 451 81189063 to update your device.",
  },
  event: {
    header: {
      events: "Latest device notifications",
    },
    loadError: "Error loading events. Please try again later or contact support.",
  },
  presence: {
    window: {
      "15min": "Short-term detected (15 Min)",
      "1h": "Medium-term detected (1 Hour)",
      "27h": "Long-term detected (27 Hours)",
    },
  },
  stateAlarms: {
    label: {
      deviceReportedStates: "Device Reported States",
      cloudReportedStates: "Cloud Reported States",
      powerSupplyStates: "Power Supply",
      braceletPresenceStates: "Bracelet States",
      braceletBatteryStates: "Bracelet Batteries",
      deviceReportedState: "Device Reported State",
      cloudReportedState: "Cloud Reported State",
      powerSupplyState: "Power Supply",
      braceletPresenceState: "Bracelet State",
      braceletBatteryState: "Bracelet Battery",
      dailyCheckIn: "Daily Check-In",
      missingDeviceDueBattery: "Missing Devices due Battery",
      missingDeviceDueUnknown: "Missing Devices Unknown",
      interruptedPower: "Interrupted Power Supply",
      missingBracelets: "Missing Bracelets",
      braceletBattery: "Critical Bracelet Battery",
      wifiConnection: "Wifi Connection",
    },
    deviceReportedPresence: {
      online: "Online",
      offlineBatteryEmpty: "Offline Empty Battery",
      offlineLowPowerMode: "Offline Low Power",
      offlineTurnedOff: "Offline Turned Off",
      unknown: "Unknown",
    },
    cloudReportedPresence: {
      online: "Online",
      offlineUnknown: "Offline Unknown",
      offlineDeviceInitiated: "Offline Device Initiated",
      offlineCloudInitiated: "Offline Cloud Initiated",
      unknown: "Unknown",
    },
    powerSupply: {
      connected: "Connected",
      disconnected: "Disconnected",
      unknown: "Unknown",
      rebooting: "Rebooting",
    },
    braceletPresence: {
      inRange: "In range",
      outOfRange: "Out of range",
      unknown: "Unknown",
    },
    braceletBattery: {
      ok: "Ok",
      critical: "Critical",
      unknown: "Unknown",
    },
    dailyCheckIn: {
      active: "Active",
      deactivated: "Deactivated",
      pausedByDevice: "Paused by device",
      pausedByPlatform: "Paused by platform",
      missing: "Missing",
      unknown: "Unknown",
    },
    notifications: {
      maxAmountTitle: "Maximum Filter",
      maxAmount: "Only three filters can be applied at the same time. Please remove one to add another one",
    },
  },
  error: {
    filter: {
      label: {
        deviceReportedStates: "Device Reported States",
        cloudReportedStates: "Cloud Reported States",
        powerSupply: "Power Supply",
        braceletStates: "Bracelet States",
        braceletBatteryState: "Bracelet Battery",
        dailyCheckIn: "Daily Check-In",
        missingDeviceDueBattery: "Missing Devices due Battery",
        missingDeviceDueUnknown: "Missing Devices Unknown",
        interruptedPower: "Interrupted Power Supply",
        missingBracelets: "Missing Bracelets",
        braceletBattery: "Critical Bracelet Battery",
      },
      state: {
        online: "Online",
        offline: "Offline",
        offlineLowPower: "Offline Low Power",
        offlineTurnedOff: "Offline Turned Off",
        offlineDeviceInitiated: "Offline Device Initiated",
        offlineCloudInitiated: "Offline Cloud Initiated",
        connected: "Connected",
        disconnected: "Disconnected",
        inRange: "In range",
        outOfRange: "Out of range",
        ok: "Ok",
        critical: "Critical",
        deactivated: "Deactivated",
        active: "Active",
        pausedByCloud: "Paused by Cloud",
        pausedByUser: "Paused by User",
        missing: "Missing",
      },
      actionLabel: {
        missingDeviceDueBattery: "Filter for Missing Devices due Battery",
        missingDeviceDueUnknown: "Filter for Missing Devices",
        interruptedPower: "Filter for Interrupted Power Supply",
        missingBracelets: "Filter for Missing Bracelets",
        braceletBattery: "Filter for Critical Bracelet Battery ",
      },
    },
    unknown: "Unknown error",
    outdated: "New version available",
    outdatedDescription:
      "This page is running an outdated version of the app. Please reload the page (Cmd/Ctrl + Shift + R) to continue.",
    notFound: "Not Found",
    searchDevice: "Please start typing the device id",
    destinationEmpty: "Destination cannot be empty.",
    receiverEmpty: "Receiver cannot be empty.",
    braceletEmpty: "Bracelet ID cannot be empty.",
    braceletFormat:
      "The Bracelet ID is not valid: Must be a 12 or 14 digits number. Examples: 006569866354 (Vibby Oak) or 2435003426474A (Vibby Oak S)",
    braceletDuplicate: "Bracelets have to be unique. Some values are duplicates.",
    braceletNotSupported:
      "Vibby Oak S are not supported by the currently installed device software. Please get in contact with our support to receive a software update.",
    sipAddressFormat: "SIP address not valid. Expected format: user@host.com",
    phoneNumberFormat: "Phone number not valid. Expected format: 004178021212",
    emailFormat: "Email address not valid. Expected format: user@host.com",
    empty: "The phone number field cannot be empty",
    permissions: "Permission Error",
    permissionsDescription: "You lack the necessary permissions to perform this action.",
  },
  search: {
    placeholder: "Search devices",
  },
  profileMenu: {
    signOut: "Sign out",
  },
  filters: {
    all: "All",
    operationStatus: "Status messages",
    allOk: "All OK",
    online: "Online",
    offline: "Offline",
    deviceNotifications: "Device Notifications",
    batteryPowered: "Device Battery mode",
    batteryEmpty: "Battery empty",
    braceletNotifications: "Bracelet Notifications",
    batteryLow: "Bracelet Battery low",
    braceletOutOfRange: "Bracelet Not reachable",
    off: "Switched off",
    dailyCheckIn: "Daily Check In",
    dailyCheckInActive: "Daily Check In Active",
    dailyCheckInMissing: "Daily Check In missing",
    dailyCheckInPaused: "Daily Check In Paused",
    dailyCheckInByUser: "By User",
    dailyCheckInPlatform: "By Platform",
    dailyCheckInDeactivated: "Inactive",
    healthNotifications: "Health Notifications",
    healthNotificationsCo2: "CO2 Indicator",
    healthNotificationsDrink: "Drink reminder",
    bracelet: "Bracelet",
    error: "Errors",
  },
  alarms: {
    alarm: "Alarms",
    sidebar: {
      critical:
        "The 'critical' severity level indicates that a service- affecting condition has occurred and an immediate corrective action is required. Such a severity can be reported, for example, when a resource becomes totally out of service and its capability must be restored.",
      major:
        "The 'major' severity level indicates that a service- affecting condition has developed and an urgent corrective action is required. Such a severity can be reported, for example, when there is a severe degradation in the capability of the resource and its full capability must be restored.",
      minor:
        "The 'minor' severity level indicates the existence of a non-service-affecting fault condition and that corrective action should be taken in order to prevent a more serious (for example, service-affecting) fault. Such a severity can be reported, for example, when the detected alarm condition is not currently degrading the capacity of the resource.",
      warning:
        "The 'warning' severity level indicates the detection of a potential or impending service-affecting fault, before any significant effects have been felt. Action should be taken to further diagnose (if necessary) and correct the problem in order to prevent it from becoming a more serious service-affecting fault.",
    },
    headers: {
      description: "Description",
      urgency: "Urgency",
      measures: "Recommended Measures",
      updatedat: "Updated at",
    },
    levels: {
      not_applicable: "Unknown",
      unknown: "Unknown",
      normal: "None",
      warning: "Warning",
      minor: "Minor",
      major: "Major",
      critical: "Critical",
    },
    network: {
      modem_link: {
        title: "Modem Connection",
        not_applicable: {
          description: "The status of the modem connection is unknown.",
          urgency: "Since CARU care is offline, the status of the modem connection cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The status of the modem connection is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "CARU care is connected to the internet via the cellular network.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The connection to the internet via the cellular network is interrupted (less than 15 minutes).",
          urgency:
            "CARU care is only connected to the internet via Wifi and is attempting to restore the connection to the cellular network on its own.",
          measures: "None",
        },
        minor: {
          description: "The connection to the internet via the cellular network is interrupted (more than 15 minutes).",
          urgency:
            "CARU care has not yet succeeded in reconnecting to the cellular network on its own. It continues to try.",
          measures:
            "Please check the location of the device on site. Relocating the device may help restore the cellular connection.",
        },
      },
      modem_connection_quality: {
        title: "Modem Connection Quality",
        not_applicable: {
          description: "The quality of the internet connection via the cellular network is unknown.",
          urgency: "Since the device is offline, the connection quality cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The quality of the internet connection via the cellular network is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "The quality of the internet connection via the cellular network is excellent.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The quality of the internet connection via the cellular network is sufficient.",
          urgency: "The connection quality is not optimal, but no impairment of voice quality is expected.",
          measures: "None",
        },
        minor: {
          description: "The quality of the internet connection via the cellular network is poor.",
          urgency:
            "The connection quality is sufficient for establishing a voice connection, but delays and interruptions may occur.",
          measures: "To ensure a stable voice connection, CARU care should be relocated if no Wifi is configured.",
        },
      },
      network_cloud_reported: {
        title: "Cloud Connection",
        not_applicable: {
          description: "CARU care has been shut down.",
          urgency: "",
          measures: "None",
        },
        unknown: {
          description: "The status of the connection to the CARU platform is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "CARU care is connected to the CARU platform.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The connection of CARU care to the CARU platform is interrupted (less than 15 minutes).",
          urgency: "CARU care is attempting to restore the connection to the CARU platform on its own.",
          measures: "None",
        },
        major: {
          description: "The connection of CARU care to the CARU platform is interrupted (less than 1 hour).",
          urgency: "Emergency calls cannot be made because CARU care is not connected to the internet.",
          measures:
            "The cause of the connection problem must be determined. Since the connection to the CARU platform is interrupted, the CARU care user must be contacted.",
        },
        critical: {
          description: "The connection of CARU care to the CARU platform is interrupted (more than 1 hour).",
          urgency: "Emergency calls cannot be made because CARU care is not connected to the internet.",
          measures:
            "The cause of the connection problem must be determined. Since the connection to the CARU platform is interrupted, the CARU care user must be contacted.",
        },
      },
      network_arc_reported: {
        title: "Alarm Center Control Call",
        not_applicable: {
          description: "The control call status is unknown.",
          urgency:
            "Since CARU care is offline or has no alarm centers configured, the control call status cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The control call status is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "The last control call to at least one of the configured centers was successful.",
          urgency: "",
          measures: "None",
        },
        major: {
          description: "The last successful control call to one of the configured centers was more than 3 hours ago.",
          urgency:
            "Emergency calls to the center cannot be made because CARU care has not received a response to the control call via SCAIP.",
          measures:
            "Check the device configuration (especially the device ID) and ask your center if a malfunction is known.",
        },
        critical: {
          description: "The last successful control call to one of the configured centers was more than 6 hours ago.",
          urgency:
            "Emergency calls to the center cannot be made because CARU care has not received a response to the control call via SCAIP.",
          measures:
            "Check the device configuration (especially the device ID) and ask your center if a malfunction is known.",
        },
      },
    },
    wifi: {
      wifi_link: {
        title: "Wifi Connection",
        not_applicable: {
          description: "The status of the Wifi connection is unknown.",
          urgency:
            "Since CARU care is offline or no Wifi is configured, the status of the Wifi connection cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The status of the Wifi connection is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "CARU care is connected to the internet via Wifi.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The connection to the internet via Wifi is interrupted (less than 15 minutes).",
          urgency:
            "CARU care is connected to the internet via cellular network and is attempting to restore the connection to Wifi on its own.",
          measures: "None",
        },
        minor: {
          description: "The connection to the internet via Wifi is interrupted (more than 15 minutes).",
          urgency:
            "CARU care is connected to the internet via cellular network and has not yet succeeded in reconnecting to Wifi on its own. It continues to try.",
          measures:
            "Please check the Wifi configuration and connection on site. The Wifi may have failed or the device may be in an unfavorable location.",
        },
      },
      wifi_connection_quality: {
        title: "Wifi Connection Quality",
        not_applicable: {
          description: "The quality of the internet connection via Wifi is unknown.",
          urgency: "Since the device is offline, the connection quality cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The quality of the internet connection via Wifi is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "The quality of the internet connection via Wifi is excellent.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The quality of the internet connection via Wifi is sufficient.",
          urgency: "The connection quality is not optimal, but no impairment of voice quality is expected.",
          measures: "Relocating CARU care may help improve the connection quality.",
        },
        minor: {
          description: "The quality of the internet connection via Wifi is poor.",
          urgency:
            "The connection quality is sufficient for establishing a voice connection, but delays and interruptions are expected.",
          measures:
            "To ensure a stable voice connection, CARU care should be relocated or the Wifi configuration should be removed.",
        },
      },
    },
    power: {
      power_supply: {
        title: "Power Supply",
        not_applicable: {
          description: "The status of the power supply is unknown.",
          urgency: "Since CARU care is offline, the status of the power supply cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The status of the power supply is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "CARU care is connected to the power grid.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "The power supply of CARU care is interrupted for less than 15 minutes.",
          urgency: "CARU care is running on battery power and can easily bridge short power outages.",
          measures: "None",
        },
        major: {
          description: "The power supply of CARU care is interrupted for more than 15 minutes.",
          urgency: "CARU care is running on battery power, but the battery life is not unlimited.",
          measures: "Measures to restore power supply must be taken if no power outages are known.",
        },
      },
      battery_fault: {
        title: "Battery Health",
        not_applicable: {
          description: "The battery status is unknown.",
          urgency: "",
          measures: "None",
        },
        unknown: {
          description: "The battery status is unknown.",
          urgency: "",
          measures: "None",
        },
        normal: {
          description: "Battery status of CARU care is normal.",
          urgency: "",
          measures: "None",
        },
        minor: {
          description: "CARU care reports a low charge level.",
          urgency: "The runtime of CARU care in battery mode is limited.",
          measures: "The battery needs to be analyzed more closely. Please contact CARU customer service.",
        },
      },
    },
    low_power_mode: {
      title: "Cloud Connection (Device in Power Saving Mode)",
      warning: {
        description:
          "CARU care is in battery mode and power saving mode is activated. To increase battery life, the cloud connection has been interrupted.",
        urgency:
          "Emergency calls are still possible. After making an emergency call, CARU care connects to the cloud and establishes a phone connection.",
        measures:
          "Contact the user and ensure that the CARU care device is connected to the power grid. This will maintain a permanent connection to the cloud.",
      },
      major: {
        description:
          "CARU care is in battery mode and power saving mode is activated. To increase battery life, the cloud connection has been interrupted.",
        urgency:
          "Emergency calls are still possible. After making an emergency call, CARU care connects to the cloud and establishes a phone connection.",
        measures:
          "Contact the user and ensure that the CARU care device is connected to the power grid. This will maintain a permanent connection to the cloud.",
      },
      critical: {
        description:
          "CARU care is in battery mode and power saving mode is activated. To increase battery life, the cloud connection has been interrupted.",
        urgency:
          "Emergency calls are still possible. After making an emergency call, CARU care connects to the cloud and establishes a phone connection.",
        measures:
          "Contact the user and ensure that the CARU care device is connected to the power grid. This will maintain a permanent connection to the cloud.",
      },
    },
    accessories: {
      bracelet_presence: {
        title: "Bracelet Control Message",
        not_applicable: {
          description: "The control message status is unknown.",
          urgency:
            "Since CARU care is offline or no bracelets are configured, the control message status cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The control message status is unknown.",
          urgency:
            "CARU care has been turned on for less than 24 hours (the bracelet sends the control message every 23 hours) or a new bracelet has been added.",
          measures: "The control message status can be determined by performing a test trigger with all bracelets.",
        },
        normal: {
          description: "A control message was received from all bracelets in the last 24 hours.",
          urgency: "",
          measures: "None",
        },
        warning: {
          description: "No control message was received from at least one bracelet in the last 24 hours.",
          urgency:
            "The bracelet was not in range of the base station at the time of the control message (every 23 hours).",
          measures: "None",
        },
        minor: {
          description: "No control message was received from at least one bracelet in the last 48 hours.",
          urgency:
            "On two consecutive days, the bracelet was not in range of the base station at the time of the control message (every 23 hours).",
          measures:
            "Contact with the participant is recommended. A malfunction can be ruled out by triggering a test call on the bracelet.",
        },
        major: {
          description: "No control message was received from at least one bracelet in the last 72 hours.",
          urgency:
            "On three or more consecutive days, the bracelet was not in range of the base station at the time of the control message (every 23 hours).",
          measures:
            "Please contact the participant. A malfunction can be ruled out by triggering a test call on the bracelet.",
        },
      },
      bracelet_battery: {
        title: "Bracelet Battery",
        not_applicable: {
          description: "The bracelet battery status is unknown.",
          urgency:
            "Since CARU care is offline or no bracelets are configured, the battery status cannot be determined.",
          measures: "None",
        },
        unknown: {
          description: "The bracelet battery status is unknown.",
          urgency: "CARU care was turned off for an extended period or a new bracelet has been added.",
          measures: "The bracelet battery status can be determined by performing a test trigger with all bracelets.",
        },
        normal: {
          description: "The bracelet battery status is normal.",
          urgency: "",
          measures: "None",
        },
        minor: {
          description: "A problem with the bracelet battery was detected.",
          urgency: "The battery should be replaced.",
          measures: "Replace the bracelet battery.",
        },
        major: {
          description: "A problem with the bracelet battery has existed for 21 days",
          urgency: "The battery must be replaced urgently.",
          measures: "Replace the bracelet battery.",
        },
        critical: {
          description: "A problem with the bracelet battery has existed for more than 28 days",
          urgency: "The battery must be replaced urgently.",
          measures: "Replace the bracelet battery.",
        },
      },
    },
    title: "Technical Alarms",
    titlePower: "Power Supply",
    titleNetwork: "Connection",
    titleWifi: "Wifi",
    titleAccessories: "Bracelets",
    power_supply: "Power supply",
    battery_fault: "Battery health",
    wifi_link: "Wifi link",
    wifi_connection_quality: "Wifi connection quality",
    modem_link: "Modem link",
    modem_connection_quality: "Modem connection quality",
    bracelet_presence: "Bracelet presence",
    bracelet_battery: "Bracelet battery",
    cloud_connection: "Cloud connection",
    mqtt_connection: "MQTT connection",
    network_cloud_reported: "Cloud Reported Network Alarm",
    network_arc_reported: "Arc Reported Network Alarm",
    unknown: "Unknown",
    normal: "Normal",
    warning: "Warning",
    minor: "Minor",
    major: "Major",
    critical: "Critical",
    wifiNotConnected: "Wifi - Not connected",
    wifiConnected: "Connected",
    networkSelection: "Network Selection",
    noNetwork: "No network selected",
    noNetworkAvailable: "No network available",
    pwdLength: "The password must be at least 8 characters long.",
    pwdLengthMax: "The password must not be longer than 63 characters.",
  },
  navigationBar: {
    userManagement: "User Management",
    configTemplates: "Configuration Templates",
    alarmCenters: "Alarm Centers",
    users: "Users",
    docs: "Handbook",
    batteryReplacement: "CARU Revision",
    deviceAlarmsNotificationSubscription: "Email Notifications",
  },
  common: {
    label: {
      useSetting: "Use setting",
      since: "since",
    },
    action: {
      cancel: "Cancel",
      save: "Save",
      edit: "Edit",
      apply: "Apply",
      leave: "Leave",
      delete: "Delete",
      search: "Search",
      clearAll: "Clear filters",
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      loadMore: "Load more ...",
    },
    filter: {
      all: "All",
      errors: "Errors",
      warnings: "Warnings",
      info: "Infos",
      user: "User",
      success: "Success",
      selectEventTypes: "Select event types ...",
      selected: "Selected event types",
    },
    noResults: "Keine Ergebnisse",
  },
  "crn::cortex.lifecycle.battery::event-type:critical": "Device Battery Critical",
  "crn::cortex.lifecycle.battery::event-type:fault": "Device Battery Error",
  "crn::cortex.lifecycle.bracelet::event-type:battery_critical": "Bracelet Battery Critical",
  "crn::cortex.lifecycle.bracelet::event-type:heartbeat": "Bracelet Heartbeat",
  "crn::cortex.lifecycle.bracelet::event-type:out_of_range": "Bracelet Out-Of-Range",
  "crn::cortex.lifecycle.system::event-type:booted": "Device-Software Started",
  "crn::cortex.lifecycle.system::event-type:bottom_button": "Device Turned Off",
  "crn::cortex.lifecycle.system::event-type:shutdown": "Device Shut Down",
  "crn::cortex.lifecycle.system::event-type:reboot": "Device Reboot",
  "crn::cortex.lifecycle.wall_adapter::event-type:connected": "Powerline Connected",
  "crn::cortex.lifecycle.wall_adapter::event-type:disconnected": "Powerline Disconnected",
  "crn::cortex.lifecycle::event-type:arc_call_v2": "Alarm Call Initiated",
  "crn::cortex.lifecycle.daily_check_in::event-type:activated": "Daily Check In Activated",
  "crn::cortex.lifecycle.daily_check_in::event-type:deactivated": "Daily Check-In Deactivated",
  "crn::cortex.lifecycle.daily_check_in::event-type:requested": "Daily Check-In Requested",
  "crn::cortex.lifecycle.daily_check_in::event-type:reminded": "Daily Check-In Reminded",
  "crn::cortex.lifecycle.daily_check_in::event-type:done": "Daily Check-In Done",
  "crn::cortex.lifecycle.daily_check_in::event-type:missing": "Daily Check-In Missing",
  "crn::cortex.lifecycle.daily_check_in::event-type:suspended_by_platform": "Daily Check-In Suspended by Platform User",
  "crn::cortex.lifecycle.daily_check_in::event-type:resumed_by_platform": "Daily Check-In Resumed by Platform User",
  "crn::cortex.lifecycle.daily_check_in::event-type:suspended_by_device": "Daily Check-In Suspended by Device User",
  "crn::cortex.lifecycle.daily_check_in::event-type:resumed_by_device": "Daily Check-In Resumed by Device User",
  "crn::cortex.lifecycle.system::event-type:low_power_enter": "Power Saving Mode Started",
  "crn::cortex.lifecycle.system::event-type:low_power_exit": "Power Saving Mode Ended",
  "crn::cortex.lifecycle.bracelet::event-type:fall_detected": "Bracelet Fall Detection",
  "crn::cortex.lifecycle.bracelet::event-type:button_pressed": "Bracelet Button Pressed",
  "crn::core.device_presence::event-type:connection_established": "Cloud Connection Established",
  "crn::core.device_presence::event-type:connection_lost": "Cloud Connection Lost",
  "crn::cortex.apps.alarm_trigger_test_mode::event-type:started": "Alarm trigger test mode started",
  "crn::cortex.apps.alarm_trigger_test_mode::event-type:ended": "Alarm trigger test mode ended",
  "crn::cortex.apps.aladdin::event-type:started": "Exercise program started",
  "crn::cortex.apps.aladdin::event-type:ended": "Exercise program beendet",
  "crn::cloud.device_state_alarms::event-type:device_state_alarms_updated": "Cloud Alarm Level Updated",
  "crn::cortex.lifecycle.bracelet::event-type:battery_ok": "Bracelet Battery Ok",
  "crn::cortex.lifecycle.hydration_reminder::event-type:played": "Hydration Reminder Played",
  "crn::cortex.lifecycle.trigger::event-type:connectivity_check": "Connectivity Check",
  "crn::cortex.lifecycle.trigger::event-type:hard_reboot": "Hard reboot",
  "crn::cortex.lifecycle.trigger::event-type:soft_reboot": "Soft reboot",
  "crn::cortex.lifecycle::event-type:device_alarm_state": "Device Alarm State updated",
};
